import * as Scrivito from "scrivito";

const TextWidget = Scrivito.provideWidgetClass("TextWidget", {
  attributes: {
    links: "linklist",
    title: "string",
    complementaryText: "html",
    body: "html",
  },
  extractTextAttributes: ["body", "title"],
});

export default TextWidget;
